<template>
    <Main>
        <el-row :gutter="20" class="search-table">
            <el-col :span="10" :xs="24" class="mb-2 mb-sm-0">
                <InputSearch v-model="keySearch" @keydown.enter="handleSearchData" @search="handleSearchData" :placeholder="$t('member.searchPlaceholder')"></InputSearch>
            </el-col>
            <el-col :span="4" :xs="24" class="mb-2 mb-sm-0">
                <SelectCustom v-model="config.dataFilter.type" :placeholder="$t('member.selectPlaceholder')">
                    <template #options>
                        <el-option v-for="(item, index) in listRoles" :value="item.value" :key="index" :label="$t(item.label)">{{ $t(item.label) }}</el-option>
                    </template>
                </SelectCustom>
            </el-col>
            <el-col :span="7" :xs="24" class="mb-2 mb-sm-0">
                <DateTimePicker
                    :date-time.sync="dateTimeUpdate"
                    :placeholder-start="$t('member.datePickerStartPlaceholder')"
                    :placeholder-finish="$t('member.datePickerEndPlaceholder')"
                ></DateTimePicker>
            </el-col>
            <el-col :span="3" :xs="24" class="text-right">
                <Button @click="$router.push('/member/add')" type="primary"> <i class="el-icon-plus"></i>{{ $t('member.buttonRegister') }} </Button>
            </el-col>
        </el-row>
        <TableBox :config="config" :reload="isReload" :data-list.sync="dataList" @updateModel="updateModel($event)">
            <template #row="{ row, index, page, perPage }">
                <tr :class="{ 'row-disabled': !row.enable }" class="row-member">
                    <td :data-title="$t('member.no')">
                        <div class="col-first">
                            {{ index + 1 + (page - 1) * perPage }}
                        </div>
                    </td>
                    <td class="col-surname" :data-title="$t('member.firstName')">{{ row.surname }}</td>
                    <td class="col-name" :data-title="$t('member.lastName')">{{ row.name }}</td>
                    <td class="col-company" :data-title="$t('member.company')">
                        {{ row.company_name }}
                    </td>
                    <td class="col-email" :data-title="$t('textCommon.mail')">{{ row.email }}</td>
                    <td class="col-role text-sm-center text-left" :data-title="$t('member.role')">
                        {{ row.type && row.type === 1 ? $t('member.roles.user') : $t('member.roles.admin') }}
                    </td>
                    <td class="col-created" :data-title="$t('member.created_at')">
                        <FormatDate :date="row.created_at" :is-kintone="true" format="YYYY/MM/DD HH:mm:DD"></FormatDate>
                    </td>
                    <td class="col-created" :data-title="$t('member.updated_at')">
                        <FormatDate :date="row.updated_at" :is-kintone="true" format="YYYY/MM/DD HH:mm:DD"></FormatDate>
                    </td>
                    <td class="col-action__middle" :data-title="$t('member.noteAdmin')">
                        {{ row.note_admin || '' }}
                    </td>
                    <td :data-title="''" class="col-action col-action__large text-sm-center text-left">
                        <div class="group-buttons">
                            <Button
                                v-if="row['setting_password'] && row['setting_password'] !== 'true'"
                                classes="btn-xs px-2 mr-2"
                                :disabled="!row.enable"
                                type="primary"
                                @click="resendEmail(row.id) || isLoadingResendEmail"
                            >
                                <el-icon class="el-icon-s-promotion"></el-icon>
                                {{ $t('button.resendEmail') }}
                            </Button>
                            <Button classes="btn-xs px-2 mr-2" :disabled="!row.enable || (userInfo.parent_id && row.id === userInfo.parent_id)" type="info" @click="handleGoEdit(row)">
                                <el-icon class="el-icon-edit"></el-icon>
                                {{ $t('button.edit') }}
                            </Button>
                            <Button
                                v-loading="isLoadingStatus"
                                classes="btn-xs px-2 mr-2"
                                :disabled="!row.parent_id || row.id === userInfo.id || isLoadingStatus ? true : false"
                                type="warning"
                                @click="changeStatusConfirm(row)"
                            >
                                <el-icon class="el-icon-set-up"></el-icon>
                                {{ !row.enable ? $t('button.active') : $t('button.deactive') }}
                            </Button>
                            <Button
                                classes="btn-xs px-2"
                                v-loading="isLoadingDelete"
                                :disabled="!row.parent_id || row.id === userInfo.id || isLoadingDelete ? true : false"
                                @click="handleDeleteConfirm(row)"
                                type="danger"
                            >
                                <el-icon class="el-icon-delete"></el-icon>
                                {{ $t('button.delete') }}</Button
                            >
                        </div>
                    </td>
                </tr>
            </template>
        </TableBox>
    </Main>
</template>

<script>
import Main from '@/components/partials/layout/Main';
import TableBox from '@/components/partials/layout/TableBox';
import Button from '@/components/partials/Button';
import InputSearch from '@/components/partials/customs/InputSearch';
import SelectCustom from '@/components/partials/customs/SelectCustom';
import DateTimePicker from '@/components/partials/customs/DateTimePicker';
import FormatDate from '@/components/partials/FormatDate';
import { mapState } from 'vuex';
export default {
    name: 'MemberList',
    components: {
        FormatDate,
        DateTimePicker,
        InputSearch,
        TableBox,
        Main,
        Button,
        SelectCustom
    },
    data: function () {
        return {
            config: {
                q: '',
                action: 'member/get_list_members',
                headers: [
                    {
                        label: 'member.no'
                    },
                    {
                        sort: 'surname',
                        label: 'member.firstName'
                    },
                    { sort: 'name', label: 'member.name' },
                    { sort: 'company_name', label: 'member.company' },
                    {
                        sort: 'email',
                        label: 'member.accountEmail'
                    },
                    {
                        sort: 'type',
                        label: 'member.role'
                    },
                    {
                        sort: 'created_at',
                        label: 'member.created_at'
                    },
                    {
                        sort: 'updated_at',
                        label: 'member.updated_at'
                    },
                    {
                        label: 'member.noteAdmin'
                    },
                    {
                        label: ''
                    }
                ],
                value: [1, 0],
                dataFilter: {
                    type: '',
                    start_updated_at: '',
                    end_updated_at: ''
                },
                sort: {
                    selected: 'id',
                    order: 'asc'
                }
            },
            isReload: false,
            keySearch: null,
            dateTimeUpdate: [],
            dataList: [],
            isLoadingStatus: false,
            isLoadingDelete: false,
            isLoadingResendEmail: false,
            listRoles: [
                { value: '', label: 'member.roles.all' },
                { value: 1, label: 'member.roles.user' },
                { value: 2, label: 'member.roles.admin' }
            ]
        };
    },
    watch: {
        dateTimeUpdate: {
            deep: true,
            handler: function (val) {
                this.config.dataFilter.start_updated_at = val ? val[0] : '';
                this.config.dataFilter.end_updated_at = val ? val[1] : '';
            }
        }
    },
    computed: {
        ...mapState('auth', ['userInfo'])
    },
    methods: {
        updateModel(e) {
            this.config.dataFilter = Object.assign({}, e.dataFilter);
            this.dateTimeUpdate[0] = e.dataFilter.start_updated_at;
            this.dateTimeUpdate[1] = e.dataFilter.end_updated_at;
            this.config.q = e.search;
            this.keySearch = e.search;
        },
        handleSearchData() {
            this.config.q = this.keySearch ? this.keySearch.toString().trim() : '';
            this.config = Object.assign({}, this.config);
        },
        handleGoEdit(row) {
            this.$router.push({ name: 'editMember', query: { id: row.id } });
        },
        resendEmail(id) {
            this.$store.commit('noticeSystem/SET_CONFIRM', {
                type: `warning`,
                isShowConfirm: true,
                message: this.$t('member.resendEmailConfirm'),
                callback: () => {
                    this.isLoadingResendEmail = true;
                    let successCallback = () => {
                        this.$store.commit('noticeSystem/SET_MESSAGE', {
                            isShowMessage: true,
                            type: 'success',
                            message: this.$t('member.resendEmailSuccess')
                        });
                        this.isLoadingResendEmail = false;
                    };
                    let errorCallback = () => {
                        this.isLoadingResendEmail = false;
                    };
                    let payload = {
                        id: id,
                        successCallback,
                        errorCallback
                    };
                    this.$store.dispatch('member/resendEmail', payload);
                }
            });
        },
        changeStatusConfirm(row) {
            this.$store.commit('noticeSystem/SET_CONFIRM', {
                type: `warning`,
                isShowConfirm: true,
                message: !row.enable ? this.$t('member.msgActiveMemberConfirm') : this.$t('member.msgDeActiveMemberConfirm'),
                callback: () => {
                    this.changStatusCallback(row);
                }
            });
        },
        changStatusCallback(row) {
            this.isLoadingStatus = true;
            let successCallback = (response) => {
                this.isReload = !this.isReload;
                this.isLoadingStatus = false;
                let message = !row.enable ? this.$t('member.msgActiveMemberSuccess') : this.$t('member.msgDeActiveSuccess');
                this.$store.commit('noticeSystem/SET_MESSAGE', {
                    isShowMessage: true,
                    type: 'success',
                    message: message
                });
            };
            let errorCallback = () => {
                this.isLoadingStatus = false;
                this.isReload = !this.isReload;
            };
            let payload = {
                successCallback,
                errorCallback,
                data: {
                    status: !row.enable
                },
                id: row.id
            };
            this.$store.dispatch('member/update_status_member', payload);
        },
        handleDeleteConfirm(row) {
            this.$store.commit('noticeSystem/SET_CONFIRM', {
                type: `warning`,
                isShowConfirm: true,
                message: this.$t('member.msgDeleteMemberConfirm'),
                callback: () => {
                    this.deleteCallback(row);
                }
            });
        },
        deleteCallback(row) {
            this.isLoadingDelete = true;
            let successCallback = (response) => {
                this.isLoadingDelete = false;
                if (response.status === 200) {
                    this.isReload = !this.isReload;
                    this.$store.commit('noticeSystem/SET_MESSAGE', {
                        isShowMessage: true,
                        type: 'success',
                        message: this.$t('member.msgDeleteMemberSuccess')
                    });
                }
            };
            let errorCallback = () => {
                this.isLoadingDelete = false;
                this.isReload = !this.isReload;
            };
            let payload = {
                successCallback,
                errorCallback,
                id: row.id
            };
            this.$store.dispatch('member/delete_member', payload);
        },
        checkResendEmail(row) {
            if (row && row['setting_password']) {
                return this.$t('d-none');
            } else {
                if (!row.enabled) {
                    return this.$t('disabled');
                }
            }
        }
    }
};
</script>
